import React, { useState, useEffect } from "react";
import Pusher from "pusher-js";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationDetail,
  getNotifications,
} from "../../redux/actions/notification";
import { base, formatTime } from "../../constants/base";
import RequestModal from "../Modals/RequestModal";
import { showDesktopNotification } from "../../constants/base";
import environment from "../../config/config";

const Notificaion = ({ userId }) => {
  const [realtimeNotifications, setRealtimeNotifications] = useState([]);
  const dispatch = useDispatch();
  const notificaions = useSelector((state) => state.notificaions);
  const pagination = useSelector((state) => state?.notificaions?.pagination);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (userId) {
      dispatch(getNotifications(userId, currentPage));
    }
  }, [userId, currentPage, dispatch]);

  const notificationHandler = async (id, userId) => {
    const data = {
      id: id,
      userId: userId,
    };
    await dispatch(getNotificationDetail(data));
  };

  useEffect(() => {
    const pusher = new Pusher("2e603f5ea3523f08e7b7", {
      cluster: "ap2",
    });

    const channel = pusher.subscribe("my-notify-channel");
    channel.bind("my-notify-event", (data) => {
      const newMessage = data.message;
      setRealtimeNotifications((preMessage) => [...preMessage, newMessage]);
      showDesktopNotification(data?.message?.title, data?.message?.description);
    });

    // Cleanup
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (notificaions.loading) {
    return (
      <div className="text-center">
        <i
          style={{ fontSize: "22px" }}
          className="fa-solid fa-spinner fa-spin"
        ></i>
      </div>
    );
  }

  return (
    <>
      {realtimeNotifications &&
        [...realtimeNotifications]
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
          .map(
            (notify) =>
              notify?.user_id == userId && (
                <div
                  className="sample-notificaions"
                  data-bs-toggle="modal"
                  href="#employe-model"
                  role="button"
                  onClick={() => notificationHandler(notify?.id, userId)}
                  key={notify.id}
                >
                  <div className="sample-notificaion-image">
                    {/* {notify?.sender &&
                      notify?.sender?.images.map((image) =>
                        image.type === "profile" || image.type === "logo" ? (
                          <img
                            src={base.imageUrl + image.path}
                            alt=""
                            key={image.id}
                          />
                        ) : (
                          ""
                        )
                      )} */}

                    {notify?.sender?.role?.name === "corporate"
                      ? notify?.request?.employee?.images &&
                        notify?.request?.employee?.images.map((image) =>
                          image.type === "profile" || image.type === "logo" ? (
                            <img src={base.imageUrl + image?.path} alt="" />
                          ) : (
                            ""
                          )
                        )
                      : notify?.sender?.images &&
                        notify?.sender?.images.map((image) =>
                          image.type === "profile" || image.type === "logo" ? (
                            <img src={base.imageUrl + image?.path} alt="" />
                          ) : (
                            ""
                          )
                        )}
                  </div>

                  <div className="sample-notificaion-text">
                    <div className="notificaion-heading">
                      <h3>{notify.title}</h3>
                      <p>{formatTime(notify.created_at)}</p>
                    </div>
                    <p>{notify.description}</p>
                  </div>
                </div>
              )
          )}

      {!notificaions.loading &&
        (notificaions.data?.data?.data?.length > 0 ? (
          notificaions.data.data.data.map((notify) => (
            <div
              className="sample-notificaions"
              data-bs-toggle="modal"
              role="button"
              href="#employe-model"
              onClick={() => notificationHandler(notify?.id, userId)}
            >
              <div className="sample-notificaion-image">
                {/* {notify?.sender?.images &&
                  notify?.sender?.images.map((image) =>
                    image.type === "profile" || image.type === "logo" ? (
                      <img src={base.imageUrl + image?.path} alt="" />
                    ) : (
                      ""
                    )
                  )} */}

                {notify?.sender?.role?.name === "corporate"
                  ? notify?.request?.employee?.images &&
                    notify?.request?.employee?.images.map((image) =>
                      image.type === "profile" || image.type === "logo" ? (
                        <img src={base.imageUrl + image?.path} alt="" />
                      ) : (
                        ""
                      )
                    )
                  : notify?.sender?.images &&
                    notify?.sender?.images.map((image) =>
                      image.type === "profile" || image.type === "logo" ? (
                        <img src={base.imageUrl + image?.path} alt="" />
                      ) : (
                        ""
                      )
                    )}
              </div>

              <div className="sample-notificaion-text">
                <div className="notificaion-heading">
                  <h3>{notify?.title}</h3>
                  <p>{formatTime(notify?.created_at)}</p>
                </div>
                <p>{notify?.description}</p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-center">No notifications available.</p>
        ))}

      <RequestModal />
    </>
  );
};

export default Notificaion;
